import React, {useEffect, useRef} from 'react'
import {Chart} from 'react-google-charts'
import {useLocation} from 'react-router-dom'

export const options = {}

export function SWC({
  label,
  textAlign = 'center',
  data = [
    ['From', 'To', 'Weight'],
    ['New Pundag', 'PLUSTIK RECYCLING FACILITY', 369],
    ['New Pundag', 'Super Plastics', 241.85],
    ['SM MEGAMALL', 'New Malaysia Recycler 1', 839.45],
    ['New Pundag', 'Central MRF & Recycling', 500],
    ['gggg', 'New Malaysia Recycler 1', 270],
    ['new tt', 'New Malaysia Recycler 1', 100],
    ['test dup 2', 'PLUSTIK RECYCLING FACILITY', 610],
    ['New Pundag', 'New Malaysia Recycler 1', 6737],
    ['test dup 2', 'Central MRF & Recycling', 25],
    ['Casablanca', 'New Malaysia Recycler 1', 500],
    ['test dup 2', 'Pet Source Pte', 400],
    ['New TEst', 'New Malaysia Recycler 1', 11],
    ['test dup 2', 'New Malaysia Recycler 1', 144],
    ['New Pundag', 'Pet Source Pte', 250],
    ['PLUSTIK RECYCLING FACILITY', 'Super Plastics', 500],
    ['Pet Source Pte', 'New Malaysia Recycler 1', 2144],
    // ['New Malaysia Recycler 1', 'Central MRF & Recycling', 3011],
    ['Pet Source Pte', 'Central MRF & Recycling', 500],
    ['CONEVERTER A', 'New Malaysia Recycler 1', 26],
    ['Super Plastics', 'New Malaysia Recycler 1', 579.5],
    // ['New Malaysia Recycler 1', 'Super Plastics', 364],
    // Removed cycle
    ['PLUSTIK RECYCLING FACILITY', 'One more MRF', 200],
    // ['New Malaysia Recycler 1', 'CONEVERTER A', 4620],
    ['Pet Source Pte', 'Super Plastics', 500],
    // ['New Malaysia Recycler 1', 'PLUSTIK RECYCLING FACILITY', 2350],
    ['Pet Source Pte', 'PLUSTIK RECYCLING FACILITY', 500],
  ],
}: any) {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const {pathname} = useLocation()
  useEffect(() => {
    const resizeChart = () => {
      if (chartRef.current) {
        chartRef.current.style.width = '100%'
        chartRef.current.style.height = '100%'
      }
    }

    // Initial resize on load
    resizeChart()

    // Add event listener for window resize
    window.addEventListener('resize', resizeChart)

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('resize', resizeChart)
    }
  }, [])

  return (
    <>
      <div
        style={{
          padding: '0.5rem',
          fontSize: '1.275rem',
          textAlign: 'left',  // Changed from dynamic textAlign to 'left'
          fontWeight: 'bold'
        }}
      >
        {label}
      </div>
      <div ref={chartRef} style={{minHeight: '400px', width: '100%'}}>
        <Chart
          chartType='Sankey'
          width='122%' 
          height={pathname.includes('/apps/leaderboard') ? '100%' : '600px'}
          data={data}
          options={options}
        />
      </div>
    </>
  )
}
